export default "/assets/remove-3fec8e191ff60f57e6edad11b98200286d3e2e49e8badc588ec74148883f3ecf.svg";